import axios from "axios";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useMemo } from "react";
import { useLiffProfile } from "../../context/LiffProfileContext";
import LoadingBar from "../LoadingBar";
import { readTouchUTM } from "../../utils/utm"; // ต้องมีฟังก์ชันนี้จริง

export default function SurveyRedirect() {
  const { t, i18n } = useTranslation();
  const { authToken, userId } = useLiffProfile();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ✅ อ่าน UTM ไว้ข้างบน (อยู่ในสโคปของ component)
  const { utm_source = "", utm_medium = "" } = useMemo(
    () => readTouchUTM() || {},
    []
  );

  useEffect(() => {
    const fetchAndRedirect = async () => {
      if (!authToken || !userId) return;

      try {
        const clientAuth = process.env.REACT_APP_CLIENT_AUTH;
        const headers = {
          Authorization: `Bearer ${authToken}`,
          "X-Client-Auth": clientAuth,
          "x-user-id": userId,
          "Accept-Language": i18n.language.toUpperCase(),
        };

         const userResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/current`,
          { headers }
        );
        const bigCardNumber = userResponse.data?.data?.bigCardNumber || "";

        const response = await axios.get(
          `${process.env.REACT_APP_BIGC_BIGLINE_API_URL}/survey-redirect`,
          {
            params: {
              lineMID: userId,
              customerId: bigCardNumber,
              source: utm_source,
            },
            headers: {
              "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
            },
          }
        );

        const redirectUrl = response.data?.data?.redirectUrl;
        if (redirectUrl) {
          //window.location.href = redirectUrl;
          window.location.href = redirectUrl;
          //window.open(redirectUrl, "_blank");
        } else {
          throw new Error("ไม่พบลิงก์สำหรับ redirect");
        }
        
      } catch (err) {
        console.error("API Error", err);
        setError("ไม่สามารถโหลดแบบสอบถามได้ในขณะนี้");
      } finally {
        setLoading(false);
      }
    };

    fetchAndRedirect();
  }, [authToken, userId, i18n.language]);

  return (
    <div className="p-4 text-center">
      {loading ? (
        <LoadingBar loading={loading} label="Loading..." />
      ) : (
        error && <p className="text-red-500">{error}</p>
      )}
    </div>
  );
}
